export const findCountry = (countriesFromApi, countryCode) => {
  if (!countriesFromApi || !countryCode) return 'No country found';

  return Object.values(countriesFromApi)?.find((country) => country?.code === countryCode)?.name?.[1] || 'No country found';
}
